module.exports = __webpack_public_path__ + "static/media/basemap_google_terrain.2b38c91b.png";